export default __webpack_public_path__ + "static/media/tickIcon.1e99dd7a.svg";